import { render, staticRenderFns } from "./recordSchool.vue?vue&type=template&id=037402f9"
import script from "./recordSchool.vue?vue&type=script&lang=ts"
export * from "./recordSchool.vue?vue&type=script&lang=ts"
import style0 from "./recordSchool.vue?vue&type=style&index=0&id=037402f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports